import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { selectTopCategories } from 'containers/catalogue/catalogue/selectors';
import { findTopCategoryData } from 'utils';
import { GAClickButton } from 'utils/analytics/analytics-events';
import { useCatalogueContentSlice } from '../../hooks';
import { selectSelectedFilterItems } from '../../selectors';

export const useLabelsContainer = () => {
	const { changeSelectedFilterItems, resetSelectedFilterItems } = useCatalogueContentSlice();

	const selectedFilterItems = useSelector(selectSelectedFilterItems);
	const topCategories = useSelector(selectTopCategories);

	const changeSelectedItems = useCallback(
		(newSelectedItems: number[]) =>
			changeSelectedFilterItems({ changedFilterItems: newSelectedItems, topCategories }),
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[changeSelectedFilterItems]
	);

	const elementBlock = 'serviceListFilter';
	const elementName = 'Список услуг';

	const labelHandler = (topCategoryId: number) => {
		changeSelectedItems([topCategoryId]);

		const { topCategoryName } = findTopCategoryData(topCategories, topCategoryId);
		GAClickButton({
			elementBlock,
			elementName,
			elementText: `${topCategoryName} - сброс`,
		});
	};

	const clearAllLabelHandler = useCallback(() => {
		resetSelectedFilterItems();

		GAClickButton({
			elementBlock,
			elementName,
			elementText: 'Сбросить все',
		});
	}, [resetSelectedFilterItems]);

	return {
		topCategories,
		selectedFilterItems,
		labelHandler,
		clearAllLabelHandler,
	};
};
